<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22">
    <path
      d="M10.981 0a11 11 0 11-10.6 14l4.224 1.743a3.119 3.119 0 006.177-.613v-.148l3.746-2.668h.094a4.149 4.149 0 10-4.156-4.149v.054l-2.627 3.8h-.174a3.107 3.107 0 00-1.755.541L.004 10.123A11.011 11.011 0 0110.981 0M6.905 16.691l-1.353-.558a2.339 2.339 0 101.281-3.2l1.4.577a1.721 1.721 0 11-1.326 3.176m5.636-8.531a2.081 2.081 0 102.08-2.076 2.078 2.078 0 00-2.08 2.076m4.845 0a2.769 2.769 0 11-2.769-2.764 2.77 2.77 0 012.769 2.764"
      fill="#fff"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String
  }
};
</script>

<style lang="scss" scoped>
.--white {
  path {
    fill: $white;
  }
}
</style>
